export default {"src":"/_next/static/media/CPRT.7c713236.svg","height":18,"width":18};